let en = {
  Title: 'Roadmap',
  Content: [
    {
      Title: '2019 Q3',
      Item: [
        'Open-SC project startup',
        'Seal-SC project startup',
      ]
    },

    {
      Title: '2019 Q4',
      Item: [
        'Open-SC alpha complete',
        'Seal-SC economic system design'
      ]
    },

    {
      Title: '2020 Q1-Q2',
      Item: [
        'Open-SC trial invitation',
        'Seal-SC  alpha complete',
      ]
    },


    {
      Title: '2020 Q3-Q4',
      Item: [
        'Open-SC release',
        'Open-SC V2 startup',
        'Seal-SC testnet release',
        'Seal CaaS project start up',
      ]
    },

    {
      Title: '2021 Q1-Q2',
      Item: [
        'Open-SC V2 release',
        'Seal-SC mainnet release',
        'Seal-SC V2 startup',
        'Seal CaaS V1 alpha complete',
      ]
    },

    {
      Title: '2021 Q3-Q4',
      Item: [
        'Seal-SC V2 release',
        'Seal CaaS release',
        'Seal BaaS project startup',
      ]
    },

    {
      Title: 'Future',
      Item: [
        'BaaS release',
        'Seal-SC developer platform release',
        'Seal-SC mainnet upgrade',
        'All Seal-SC services move to Seal mainnet',
      ]
    },
  ]
}




let zh = {
  Title: '路线图',
  Content: [
    {
      Title: '2019 Q3',
      Item: [
        'Open-SC 项目启动',
        'Seal Oracle 项目启动',
      ]
    },

    {
      Title: '2019 Q4',
      Item: [
        'Open-SC V1 alpha 版本完成',
        'Seal Oracle 链和经济模型设计'
      ]
    },

    {
      Title: '2020 Q1-Q2',
      Item: [
        'Open-SC V1 体验版邀请试用',
        'Seal Oracle 链V1完成',
      ]
    },


    {
      Title: '2020 Q3-Q4',
      Item: [
        'Open-SC V1 版本上线',
        'Open-SC V2 版本启动',
        'Seal Oracle 测试网上线',
        'Seal CaaS 项目启动',
      ]
    },

    {
      Title: '2021 Q1-Q2',
      Item: [
        'Open-SC V2 上线',
        'Seal Oracle V1 主网上线',
        'Seal Oracle V2 版本启动',
        'Seal CaaS V1 alpha 版本完成',
      ]
    },

    {
      Title: '2021 Q3-Q4',
      Item: [
        'Seal Oracle V2上线',
        'Seal CaaS V1上线.',
        'Seal BaaS 项目启动',
      ]
    },

    {
      Title: 'Future',
      Item: [
        'BaaS上线',
        'Seal-SC 开发者平台上线',
        'Seal 协议升级',
        '所有Seal服务前移至Seal主网',
      ]
    },
  ]
}


let name = 'RoadMap'

export default {
  name,
  en,
  zh
}